import React from "react";
import { Row, Col } from "reactstrap";
import { CircularProgressbar } from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";

const PerformaceScore = (props) => {
  const { desktopScore, mobileScore } = props;

  const deviceScore = [
    { type: "desktop", score: desktopScore },
    { type: "mobile", score: mobileScore },
  ];
  // const getSeiCirleOption = (score) => {
  //   const tempScore = parseInt(score * 100);
  //   let arcColor = "#f9a02e";
  //   if (tempScore < 50) arcColor = "#f24c40";
  //   if (tempScore > 89) arcColor = "#43bac5";
  //   const semicircle_options = {
  //     text: {
  //       value: tempScore,
  //       color: "#323c5a",
  //       className: "progressbar__text",
  //     },
  //     color: arcColor,
  //     duration: 1000,
  //     strokeWidth: 8,
  //     trailColor: "#efeef8",
  //   };
  //   return semicircle_options;
  // };

  const getColor = (tempScore) => {
    const score = parseInt(tempScore * 100);
    let color = "#f9a02e";
    if (score < 50) color = "#f24c40";
    if (score > 89) color = "#43bac5";
    return color;
  };

  return (
    <div className="performaceDevice bg-white">
      <Row className="dataRow mx-0 border-right-0">
        {deviceScore &&
          deviceScore.map((device) => (
            <Col xs="6" className="p-5 border-right">
              <div className="d-flex justify-content-center align-items-center catogaryHeading mb-4 text-size-24 color-indigo-900">
                {device.type === "mobile" ? "Mobile" : "Desktop"} Score
              </div>
              <Row>
                <Col className="scoreInfo">
                  <div className="d-flex justify-content-end">
                     {/* <SemiCircle
                        progress={device.score}
                        options={getSeiCirleOption(device.score)}
                        container_style={{
                          width: "120px",
                          strokeLinecap: "round",
                        }}
                      /> */}
                    <div className="progressbarDevice">
                    <CircularProgressbar
                        value={(device.score * 100) / 2}
                        text={parseInt(device.score * 100) === 0 ? "?":parseInt(device.score * 100) }
                        strokeWidth={8}
                        styles={{
                          path: {
                            stroke: `${getColor(device.score)}`,
                            strokeLinecap: "round",
                            transition: "stroke-dashoffset 0.5s ease 0s",
                            transform: "rotate(0.75turn)",
                            transformOrigin: "center center",
                          },
                          trail: {
                            // stroke: "#000000",
                            strokeLinecap: "round",
                            transform: "rotate(0.5turn)",
                            transformOrigin: "center center",
                          },
                          text: {
                            fill: getColor(device.score),
                            fontSize: parseInt(device.score * 100) === 0 ? "20px" : '16px',
                            fontWeight: parseInt(device.score * 100) === 0 ? "normal" : "bold",
                          },
                        }}
                      />
                    </div>
                    <div style={{position:"absolute", top:"83px",left:"53px", height:"50px",width:"120px", background:"#ffffff"}}>
                    </div>
                  </div>
                </Col>
                <Col className="scoreInfo">
                  <div className="infoItem">
                    <div className="dot"></div>
                    Poor
                  </div>
                  <div className="infoItem">
                    <div className="dot dotYello"></div>
                    Average
                  </div>
                  <div className="infoItem">
                    <div className="dot dotGreen"></div>
                    Optimum
                  </div>
                </Col>
              </Row>
            </Col>
          ))}
      </Row>
    </div>
  );
};

export default PerformaceScore;
